jQuery(document).ready(function () {
    $(document).on('change', '#ticket_voucher_type', function (e) {
        var selected = $("option:selected", this).val();
        var inputPercentage = $('.value-percent-of-reduction-container');
        var inputAmount = $('.value-of-reduction-container');
        var containerTypeOfReduction = $('.type-of-reduction-container');

        if (selected == "amount") {
            inputPercentage.addClass('hidden');
            inputAmount.removeClass('hidden');
            containerTypeOfReduction.removeClass('hidden');
        } else if (selected == "percentage") {
            inputPercentage.removeClass('hidden');
            inputAmount.addClass('hidden');
            containerTypeOfReduction.addClass('hidden');
        } else if (selected == "free-ticket" || selected == "0") {
            inputPercentage.addClass('hidden');
            inputAmount.addClass('hidden');
            containerTypeOfReduction.addClass('hidden');
        }
    });
});


jQuery(document).ready(function () {
    var infoVoucherCodesGenerating = $('#ticketVoucher-codes-generating');

    if (infoVoucherCodesGenerating.length) {
        var checkTimer = setInterval(function() {

            $.ajax({
                type: "GET",
                url: window.location.href,
                success: function (response) {
                    var infoVoucherCodesGenerated = $('#ticketVoucher-codes-generated', response);

                    if (infoVoucherCodesGenerated.length) {

                        infoVoucherCodesGenerating.replaceWith(infoVoucherCodesGenerated);

                        clearInterval(checkTimer);
                    }
                }
            });
        }, 4000);
    }
});